import React from 'react'
import ErrorPage4 from '../Pages/ErrorPages/error-page4'

const AccessDenied = ({ coordination, setPageAllow }) => {
  return (
    <div><ErrorPage4 setPageAllow={setPageAllow} coordination={coordination} /></div>
  )
}

export default AccessDenied